/*code reference from @material_ui component Dialog https://material-ui.com/components/dialogs/*/
/*And just like CustomDecisionPopup*/
import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import CustomInput from "components/General/Form/CustomInput";

const CustomDialog = withStyles((theme) => ({
    paper: {
      borderRadius: "10px",
      padding: "8px",
    },
}))(MuiDialog);

function CustomInputPopup (props) {
        return(
            <div>
                <CustomDialog
                    open = {true}
                    onClose = {()=>(props.declineButtonClick())}
                >
                    <DialogTitle>
                        <div style={{paddingBottom: "10px", borderBottom: "1.5px #e3e3e3 solid"}}>
                        <TextTheme
                            className = "text_bold text_medium text_dark_blue"
                            message = {props.popupTitle}
                        />
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style = {{width: "470px"}}/>
                        <div style = {{width: "100%", height: "60px"}}>
                            <CustomInput
                                placeholder = {props.inputPlaceholder}
                                handleChange = {props.textOnChange}
                            />
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <div style = {{width: "55%", marginRight: "4%"}}>
                            <TwoButtonLayout button1Text={props.declineButtonText} button2Text={props.acceptButtonText}
                                button1Click={()=>(props.declineButtonClick())}
                                button2Click={()=>(props.acceptButtonClick())}
                                marginLeft = "0%"
                                marginRight = "8%"
                                width = "100%"
                            />
                        </div>
                    </DialogActions>
                </CustomDialog>
            </div>
        );

}

export default CustomInputPopup;